import React from "react";
import { Route, Redirect } from "react-router-dom";
import { useSelector } from 'react-redux';

import GroupMenu from "src/components/group-menu";
import APIKeys from "./pages/api-keys";
import Webhooks from "./pages/webhooks";
import APIKeyCreate from "./pages/api-keys/create";
import WebhookCreate from "./pages/webhooks/create";
import WebhookNotifications from './pages/webhooks/notifications';
import WebhookLogs from './pages/webhooks-logs';
import Styling from './pages/styling';

import RedirectRenderer from "src/components/redirect-renderer";

import HasFeature from "src/utils/has-feature";
import HasRole from "src/utils/has-role";

import { CodeBracketIcon, MegaphoneIcon, QueueListIcon } from "@heroicons/react/24/outline";
import GroupContainer from "src/components/group-container";

const Layout = ({ children }) => {
  const { organisation: { features }, account: { account } } = useSelector((state) => state);

  const items = [
    { name: 'API Keys', description: 'View and manage your API keys to access the Felloh API', icon: CodeBracketIcon, path: '/developers/api-keys', check: HasRole(account, ['developers:manage:keys']) && HasFeature(features, ['developers']) },
    { name: 'Webhook Congifuration', description: 'View and manage your webhooks to receive notifications', icon: MegaphoneIcon, path: '/developers/webhooks', check: HasRole(account, ['developers:manage:webhooks']) && HasFeature(features, ['developers']) },
    { name: 'Webhook Logs', description: 'View and debug the log requests of your webhooks', icon: QueueListIcon, path: '/developers/webhooks/logs', check: HasRole(account, ['developers:manage:webhooks']) && HasFeature(features, ['developers']) },
    { name: 'Webhook Management', description: 'Manage your which notifications your webhook will receive', parent: 'Webhook Congifuration', visible: false, icon: QueueListIcon, path: '/developers/webhook', check: HasRole(account, ['developers:manage:webhooks']) && HasFeature(features, ['developers']) },
    { name: 'Styling', description: 'Add custom CSS styling for your Payment Pages', path: '/developers/styling', check: HasRole(account, ['organisation:management']) && HasFeature(features, ['developers']) },

    { name: 'Create API Key', description: 'Create a new API key to access the Felloh API', parent: 'API keys', icon: CodeBracketIcon, path: '/developers/api-keys/create', visible: false, check: HasRole(account, ['developers:manage:keys']) && HasFeature(features, ['developers']) },
    { name: 'Create Webhook', description: 'Create a new webhook to receive notifications', parent: 'Webhook Congifuration', visible: false, icon: MegaphoneIcon, path: '/developers/webhooks/create', check: HasRole(account, ['developers:manage:webhooks']) && HasFeature(features, ['developers']) },
  ];

  return (
    <div id="content">
      <GroupMenu items={items} title="Developers" />
      <GroupContainer>
        {children}
      </GroupContainer>
    </div>
  )
};

let redirects = [
  { from: '/developers', to: '/developers/api-keys' },
];

const BasePathRenderer = () => {
  const { organisation: { features }, account: { account } } = useSelector((state) => state);

  let path = '/';

  if (HasRole(account, ['developers:manage:keys']) && HasFeature(features, ['developers'])) {
    path = `/developers/api-keys`;
  }

  if (HasRole(account, ['developers:manage:webhooks']) && HasFeature(features, ['developers'])) {
    path = `/developers/webhooks`;
  }

  if (HasRole(account, ['organisation:management']) && HasFeature(features, ['developers'])) {
    path = `/developers/styling`;
  }

  return (
    <Route exact path="/developers" component={(props) => {
      return (
        <Redirect to={path} />
      )
    }}
    />
  );
};

const Developers = () => {
  const { organisation: { features }, account: { account } } = useSelector((state) => state);

  if (HasRole(account, ['developers:manage:keys']) === false) {
    redirects = { from: '/developers', to: '/developers/webhooks' };
  }

  if (account?.id) {
    return (
      <React.Fragment>

        {RedirectRenderer({ redirects })}
        {BasePathRenderer()}

        {HasRole(account, ['organisation:management']) && HasFeature(features, ['developers']) && (
          <React.Fragment>
              <Route exact path={`/developers/styling`} component={() => <Layout><Styling /></Layout>} />
          </React.Fragment>
        )}

        {HasRole(account, ['developers:manage:keys']) && HasFeature(features, ['developers']) && (
          <React.Fragment>
            <Route exact path={`/developers/api-keys/create`} component={() => <Layout><APIKeyCreate /></Layout>} />
            <Route exact path={`/developers/api-keys`} component={() => <Layout><APIKeys /></Layout>} />
          </React.Fragment>
        )}

        {HasRole(account, ['developers:manage:webhooks']) && HasFeature(features, ['developers']) && (
          <React.Fragment>
            <Route exact path={`/developers/webhooks`} component={() => <Layout><Webhooks /></Layout>} />
            <Route exact path={`/developers/webhooks/logs`} component={() => <Layout><WebhookLogs /></Layout>} />
            <Route exact path={`/developers/webhooks/create`} component={() => <Layout><WebhookCreate /></Layout>} />
            <Route exact path={`/developers/webhook/:id`} component={() => <Layout><WebhookNotifications /></Layout>} />
          </React.Fragment>

        )}

      </React.Fragment>
    );
  }

  return <React.Fragment />;
};

export default Developers;

